<template>
  <a-form-item class="checkbox-item-row">
    <a-checkbox
      :indeterminate="indeterminate"
      :checked="checkAll"
      @change="onCheckAllChange"
    >
      {{ index === 1 ? $t('message["410"]') : $t('message["330"]') }}
      <em class="checkbox-tip">
        {{ index === 1 ? checkboxTiptxt[0] : checkboxTiptxt[1] }}
      </em>
    </a-checkbox>
    <div class="checkbox-group-item">
      <a-checkbox-group
        v-model="item.selecteduserid[`sysrole${indexT}`]"
        :options="item[`sysrole${indexT}`]"
        @change="onChange"
      />
    </div>
  </a-form-item>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      indeterminate: false,
      checkAll: false,
      checkedList: []
    }
  },
  computed: {
    indexT () {
      return this.index * 1 + 1
    },
    checkboxTiptxt () {
      return this.$t('message["573"]').split('|')
    }
  },
  mounted () {
    const plainOptions = this.item[`sysrole${this.indexT}`]
    const checkedList = this.item.selecteduserid[`sysrole${this.indexT}`]
    this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length
    this.checkAll = checkedList.length === plainOptions.length && !!plainOptions.length
  },
  methods: {
    onChange (checkedList) {
      // const checkedList = this.item.selecteduserid[`sysrole${this.indexT}`]
      const plainOptions = this.item[`sysrole${this.indexT}`]
      this.item.selecteduserid[`sysrole${this.indexT}`] = checkedList
      this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length
      this.checkAll = checkedList.length === plainOptions.length && !!plainOptions.length
    },
    onCheckAllChange (e) {
      // let checkedList = this.item.selecteduserid[`sysrole${this.indexT}`]
      const plainOptions = this.item[`sysrole${this.indexT}`].map(item => {
        return item.value
      })
      Object.assign(this, {
        // checkedList: e.target.checked ? plainOptions : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
      this.item.selecteduserid[`sysrole${this.indexT}`] = e.target.checked ? plainOptions : []
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox-item-row {
  margin-bottom: 0 !important;
  .checkbox-tip {
    color: #b3b3b3;
    margin-left: 8px;
    font-style: normal;
  }
}
</style>
